<template>
  <div class="cc-container">
    <!-- ── Breadcrumb + Título ── -->
    <div class="cc-page-header mb-5">
      <v-btn @click="goRoute('/cajas')" text color="primary" class="cc-back-btn pl-0">
        <v-icon left small>mdi-chevron-left</v-icon>
        Regresar a puntos de venta
      </v-btn>
      <h1 class="cc-page-title">
        Cierres y aperturas
        <span class="cc-page-subtitle" v-if="instalacionData.Nomb">— {{ instalacionData.Nomb }}</span>
      </h1>
    </div>

    <v-row>
      <!-- ══════════ Sección 1: Aperturas activas ══════════ -->
      <v-col cols="12">
        <v-card class="cc-card" rounded="lg" elevation="1">
          <div class="cc-card-header">
            <span class="cc-card-title">Sesiones activas</span>
            <v-chip small outlined color="grey darken-1">
              {{ data_cajas.length }} sesiones
            </v-chip>
          </div>
          <v-divider></v-divider>
          <v-card-text class="pa-4">
            <uv-data-table :config="config" :data="data_cajas" :pageRows="15"
              @buttonClick="dtButtonClick"></uv-data-table>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- ══════════ Sección 2: Histórico de cierres ══════════ -->
      <v-col cols="12">
        <v-card class="cc-card" rounded="lg" elevation="1">
          <div class="cc-card-header">
            <span class="cc-card-title">Histórico de cierres</span>
          </div>
          <v-divider></v-divider>

          <!-- Filtro de fechas -->
          <v-card-text class="cc-filter-section">
            <v-row align="center">
              <v-col cols="12" sm="5">
                <v-menu :close-on-content-click="false" max-width="290">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field :value="startDate" label="Fecha Inicial" readonly v-bind="attrs" v-on="on"
                      outlined dense hide-details prepend-inner-icon="mdi-calendar-start" class="cc-date-field">
                    </v-text-field>
                  </template>
                  <v-date-picker v-model="startDate"></v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="12" sm="5">
                <v-menu :close-on-content-click="false" max-width="290">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field :value="endDate" label="Fecha Final" readonly v-bind="attrs" v-on="on"
                      outlined dense hide-details prepend-inner-icon="mdi-calendar-end" class="cc-date-field">
                    </v-text-field>
                  </template>
                  <v-date-picker v-model="endDate"></v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="12" sm="2">
                <v-btn @click="getCierre()" color="primary" depressed block class="cc-search-btn">
                  <v-icon left small>mdi-magnify</v-icon>
                  Buscar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider></v-divider>

          <!-- Tabla de histórico -->
          <v-card-text class="pa-0">
            <v-data-table :headers="headers" :items="data_cierres" class="cc-history-table"
              no-data-text="No se encontraron registros para este rango de fechas">

              <template v-slot:item.instalacion="{ item }">
                <div class="cc-instalacion-cell">
                  <span class="cc-instalacion-name">{{ item.instalacion }}</span>
                  <span class="cc-instalacion-meta">
                    ID: {{ item.id }}
                  </span>
                  <span class="cc-instalacion-meta">
                    Turno: {{ item.Turno }}
                  </span>
                </div>
              </template>

              <template v-slot:item.Tipo="{ item }">
                <v-chip small label
                  :color="item.Tipo === 'Cierre' ? '#e8f5e9' : '#e3f2fd'"
                  :text-color="item.Tipo === 'Cierre' ? '#2e7d32' : '#1565c0'"
                  class="font-weight-medium">
                  <v-icon left x-small>{{ item.Tipo === 'Cierre' ? 'mdi-lock-outline' : 'mdi-lock-open-variant-outline' }}</v-icon>
                  {{ item.Tipo }}
                </v-chip>
              </template>

              <template v-slot:item.actions="{ item }">
                <v-btn v-if="item.Tipo == 'Cierre'" @click="viewDetail(item)" small depressed
                  color="primary" class="cc-detail-btn text-none">
                  <v-icon small class="mr-1">mdi-eye-outline</v-icon>
                  Ver Detalle
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Modal -->
    <modal :ref="'modalForm'" v-model="showModal" :showFooter="false" title="Productos">
      <CajaTotales :edit="editMode" :key="formIndex" @toggle="toggleModal" @closeAndReload="receiveReload"
        :dataEdit="editData" :CajaInstalacion="CajaInstalacion">
      </CajaTotales>
    </modal>
  </div>
</template>

<script>
import moment from "moment";
import uvDataTable from "../MainComponents/DataTable.vue";
import modal from "../MainComponents/modal.vue";
import CajaTotales from "../Cajas/CajaTotales.vue";

export default {
  name: "CajaCrud",
  components: {
    uvDataTable,
    CajaTotales,
    modal,
  },
  data() {
    return {
      headers: [
        {
          text: "Instalacion",
          align: "start",
          filterable: false,
          value: "instalacion",
          format: (row) => {
            return (row.instalacion + "<br/> Identificador:" + row.id)
          },
        },
        {
          text: "Cajero",
          align: "start",
          filterable: false,
          value: "CajeroNombre",
        },
        {
          text: "Departamento",
          align: "start",
          filterable: false,
          value: "Departamentos",
        },
        {
          text: "Fecha",
          align: "start",
          filterable: false,
          value: "Momento",
        },
        {
          text: "Tipo",
          align: "start",
          filterable: false,
          value: "Tipo",
        },
        { text: "Actions", value: "actions", sortable: false },
      ],
      startDate: new moment().format("YYYY-MM-DD"),
      endDate: new moment().format("YYYY-MM-DD"),
      formIndex: 0,
      editMode: false,
      editData: {},
      access: [],
      showModal: false,
      CajaInstalacion: false,
      config: {
        orderByCol: { Field: "", Type: "Asc" },
        selectableRow: true,
        allowExport: false,
        rawText: "Cajas PDV",
        selectConfig: {
          idRowData: "id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        buttons: [
          {
            text: "Ver Totales",
            icon: "lni lni-graph",
            buttonId: "verTotales",
            require: true,
          },
        ],
        fields: [
          {
            text: "Cajero",
            value: "Cajero",
            format: (row) => {
              let nombre = this.$pgsHelper.getById(
                this.cashiers,
                "Id",
                row["Cajero"]
              ).Nomb;
              return nombre;
            },
          },
          {
            text: "Identificador",
            value: "id",
          },
          {
            text: "Tipo",
            value: "Tipo",
          },
          {
            text: "Estatus",
            value: "Etts",
            format: (row) => {
              return row["Etts"] == "A" ? "Abierto" : "Cerrado";
            },
          },
        ],
      },
      fullAccess: false,
      idSelected: "",
      data_cajas: [],
      data_cierres: [],
      cashiers: [],
      instalacionData: {},
    };
  },

  methods: {
    goRoute(routePath) {
      this.$router.push({ path: routePath });
    },
    dtButtonClick(buttonId, idSelected) {
      this.formIndex++;
      if (buttonId == "verTotales") {
        this.idSelected = idSelected[0];
        const caja = this.$pgsHelper.getById(
          this.data_cajas,
          "id",
          idSelected[0]
        );

        if (caja.Etts != "A") {
          this.$swal(
            "La caja no esta abierta",
            "No puedes ver los totales cuando la caja esta cerrada",
            "error"
          );
          return false;
        }

        this.editMode = true;
        this.editData = this.$pgsHelper.cloneObj(caja);

        this.CajaInstalacion = true;

        this.$refs.modalForm.setTitle("Contadores de la caja");
        this.toggleModal(true);
      }
    },
    viewDetail(item) {
      this.formIndex++;
      this.editMode = true;

      this.data_cierres;
      this.editData = this.$pgsHelper.cloneObj(item);
      this.CajaInstalacion = false;

      this.$refs.modalForm.setTitle("Contadores totales de la caja");

      this.toggleModal(true);
    },
    async receiveReload() {
      await this.getCierre();
      this.toggleModal(false);
    },
    async getCajas() {
      const data = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "PDV/CCSesion"
      );
      this.data_cajas = [];
      let data_cajas = this.$pgsHelper.ArrayObjectToArray(data.val());
      data_cajas.forEach((caja) => {
        if (caja.Caja == this.$route.params.idInstalacion) {
          this.data_cajas.push(caja);
        }
      });
    },
    async getInstalacion() {
      const data = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "PDV/Cajas/" + this.$route.params.idInstalacion
      );
      this.instalacionData = data.val();
    },
    async getCashiers() {
      const snapshot = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "PDV/Cajeros"
      );

      if (snapshot.exists()) {
        this.cashiers = [];
        Object.keys(snapshot.val()).forEach((id) => {
          const toAdd = snapshot.val()[id];
          if (toAdd) {
            toAdd.Id = id;

            // ajustar usuarios antiguos
            this.cashiers.push(toAdd);
          }
        });
      }
    },
    async getCierre() {
      /*await this.$store.getters.getFirebaseApp.database
        .ref("PDV")
        .once("value", (snapshot) => {
          if (snapshot.exists()) {
          }
        });*/
      const startDate = this.startDate;
      const endDate = this.endDate;
      const end = endDate.replace(/.$/, (c) =>
        String.fromCharCode(c.charCodeAt(0) + 1)
      );
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      const data = await firestore.queryBuilder("PDV_CierreApertura", [
        firestore.where("Momento", ">=", startDate),
        firestore.where("Momento", "<", end),
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
        firestore.where("Caja", "==", this.$route.params.idInstalacion),
        firestore.where("Tipo", "in", ["Apertura", "Cierre"]),
      ]);
      let cierres = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });
      cierres.forEach((element) => {
        element.CajeroNombre = this.$pgsHelper.getById(
          this.cashiers,
          "Id",
          element.Cajero
        ).Nomb;
        element.instalacion = this.instalacionData.Nomb;
      });

      this.data_cierres = cierres;
    },

    toggleModal(open) {
      this.showModal = open;
    },
  },
  beforeMount: function () { },
  mounted: async function () {
    await this.getInstalacion();
    await this.getCashiers();
    await this.getCajas();
    await this.getCierre();
  },
};
</script>

<style scoped>
/* ─── Container ─── */
.cc-container {
  font-family: "Poppins", sans-serif;
  max-width: 1200px;
}

/* ─── Page Header ─── */
.cc-page-header {
  padding: 0 4px;
}

.cc-back-btn {
  font-size: 13px !important;
  text-transform: none !important;
  letter-spacing: 0.2px !important;
  margin-bottom: 4px;
}

.cc-page-title {
  font-size: 22px;
  font-weight: 700;
  color: #263238;
  margin: 0;
  line-height: 1.3;
}

.cc-page-subtitle {
  font-weight: 400;
  color: #78909c;
  font-size: 20px;
}

/* ─── Cards ─── */
.cc-card {
  overflow: hidden;
}

.cc-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
}

.cc-card-title {
  font-size: 16px;
  font-weight: 600;
  color: #37474f;
  letter-spacing: 0.2px;
}

/* ─── Filter Section ─── */
.cc-filter-section {
  background: #fafbfc;
  padding: 16px 20px !important;
}

.cc-date-field {
  background: white;
  border-radius: 8px;
}

.cc-search-btn {
  text-transform: none !important;
  font-weight: 600 !important;
  letter-spacing: 0.3px !important;
  border-radius: 8px !important;
  height: 40px !important;
}

/* ─── History Table ─── */
.cc-history-table >>> .v-data-table-header th {
  font-size: 12px !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  color: #546e7a !important;
  background: #f5f7f9 !important;
  border-bottom: 2px solid #e0e6eb !important;
  padding: 10px 16px !important;
}

.cc-history-table >>> tbody tr {
  transition: background-color 0.15s ease;
}

.cc-history-table >>> tbody tr:hover {
  background-color: #f5f9fc !important;
}

.cc-history-table >>> tbody td {
  padding: 12px 16px !important;
  font-size: 13px !important;
  color: #455a64 !important;
  border-bottom: 1px solid #f0f3f5 !important;
}

/* ─── Instalacion Cell ─── */
.cc-instalacion-cell {
  display: flex;
  flex-direction: column;
  padding: 4px 0;
}

.cc-instalacion-name {
  font-weight: 600;
  color: #263238;
  font-size: 13px;
  margin-bottom: 2px;
}

.cc-instalacion-meta {
  font-size: 11px;
  color: #90a4ae;
  line-height: 1.5;
}

/* ─── Detail Button ─── */
.cc-detail-btn {
  border-radius: 6px !important;
  font-weight: 500 !important;
  letter-spacing: 0.2px !important;
}

/* ─── Responsive ─── */
@media (max-width: 600px) {
  .cc-page-title {
    font-size: 18px;
  }

  .cc-page-subtitle {
    font-size: 16px;
  }

  .cc-card-header {
    padding: 14px 16px;
  }
}
</style>
